import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import Session from '../../Service/Session';
import LoanService from '../../Service/LoanService';
import Main from './Landing';
import List from './List';
import Loader from '../Common/Loader';
import Details from './Details';
import LoanAgreement from '../Common/LoanAgreement';
import LoanAgreementGuarantorBorrower from '../Common/LoanAgreementGuarantorBorrower';
import LoanAgreementGuarantorLender from '../Common/LoanAgreementGuarantorLender';
import AmortizationTableComponent from '../AmortizationTableComponent';
import ViewModification from '../LoanList/ViewModification';
import ModifyDetails from '../LoanList/ModifyDetails';
import UpdateLoan from '../LoanList/UpdateLoan';
import { checkIfLender } from '../../AppUtil/AppUtil';
import { toastUserCanceledLoan } from '../../SweetAlertUtil/util';
import DetailsGuarantor from './DetailsGuarantor';
import DownloadDocuments from './DownloadDocuments';
import html2pdf from 'html2pdf.js';

const APP_STRING = window.AppStrings;
const LOAN_TYPES = window.AppConfig.LOAN_TYPES;
const LOAN_STATES = window.AppConfig.LOAN_STATES;
const GUARANTOR_STATE = window.AppConfig.GUARANTOR_STATE;

let LoanObjects = [];

class Index extends Component {
	constructor(props) {
		super(props);
		this.state = {
			_lendPendingOffers: [],
			_lendPendingRequests: [],
			_borrowPendingOffers: [],
			_borrowPendingRequests: [],
			_tableColor: '',
			_lendPending: [],
			_lendApprove: [],
			_lendDecline: [],
			_lendModified: [],
			_lendCompleted: [],
			_borrowPending: [],
			_borrowApprove: [],
			_borrowDecline: [],
			_borrowModified: [],
			_borrowCompleted: [],
			_lendPaused: [],
			_borrowPaused: [],
			_currentUserId: null,
			_loanObject: null,
			_whenRefresh: false,
			_hashedLoanObjects: {},
			_lendLoanObjects: [],
			_borrowLoanObjects: [],
			_isObjectLoading: false,
			_refreshWhenModifiedClose: false,
			_tableType: '',
			_modifiedAmortization: [],
			_fromModifiedState: false,
			_open: '',
			_loanListObjects: [],
			_guarantorPending: [],
			_guarantorDecline: [],
			_guarantorAccepted: [],
			_guarantorCompleted: [],
			_guarantorLoanObjects: [], //this is for guarantor but on line 114 _borrowLoanObjects is used instead of this
			userType: 'USER',
			_pageHeaderTitle: '',
			_pageHeaderDescription: '',
			users: {}
		};
	}

	setScreenThroughRouters = () => {
		// NOSONAR
		let Loans = this.state._lendLoanObjects;

		let isLoanObjectExist = false;
		for (const loanObject of Loans) {
			if (loanObject.id === parseInt(this.props.props.match.params.id)) {
				isLoanObjectExist = true;
				if (
					this.props.props.match.path === '/loan/:id' ||
					this.props.props.match.path === '/amortization-table/:id' ||
					this.props.props.match.path === '/modify-loan/:id'
				) {
					this.setState({
						_open: 'LIST',
						_tableType: 'LEND'
					});
					LoanObjects = this.state._lendLoanObjects;
				}
			}
		}
		Loans = this.state._borrowLoanObjects;
		for (const loanObject of Loans) {
			if (loanObject.id === parseInt(this.props.props.match.params.id)) {
				isLoanObjectExist = true;
				if (
					this.props.props.match.path === '/loan/:id' ||
					this.props.props.match.path === '/amortization-table/:id' ||
					this.props.props.match.path === '/modify-loan/:id'
				) {
					this.setState({
						_open: 'LIST',
						_tableType: 'BORROW'
					});
					LoanObjects = this.state._borrowLoanObjects;
				}
			}
		}
		Loans = this.state._guarantorLoanObjects;
		for (const loanObject of Loans) {
			console.log(loanObject);

			if (loanObject.id === parseInt(this.props.props.match.params.id)) {
				isLoanObjectExist = true;
				if (
					this.props.props.match.path === '/loan/:id' ||
					this.props.props.match.path === '/amortization-table/:id' ||
					this.props.props.match.path === '/modify-loan/:id'
				) {
					this.setState({
						_open: 'LIST',
						_tableType: 'GUARANTOR'
					});
					LoanObjects = this.state._borrowLoanObjects;
				}
			}
		}
		if (this.props.props.match.params.id && !isLoanObjectExist) {
			toastUserCanceledLoan();
		}
		this.props.props.history.push('/');
	};

	handleBackFromList = () => {
		this.setState({
			_open: ''
		});
	};

	closeLoanDetail = () => {
		if (
			this.props.props.match.path === '/loan/:id' ||
			this.props.props.match.path === '/amortization-table/:id' ||
			this.props.props.match.path === '/modify-loan/:id'
		) {
			this.props.props.history.push('/');
		}
		this.setState({
			_open: 'LIST',
			_refreshWhenModifiedClose: false
		});
	};

	startLoader() {
		this.setState({
			_isObjectLoading: true
		});
	}

	stopLoader() {
		this.setState({
			_isObjectLoading: false
		});
	}

	generatePDF = () => {
		this.startLoader();
		const input = document.getElementById('pdf-container');
		var opt = {
			margin: [15, 15],
			filename: `${this.state._open}-${this.state._loanObject.id}.pdf}`,
			image: { type: 'jpeg', quality: 0.98 },
			html2canvas: { scale: 2, letterRendering: true },
			jsPDF: { unit: 'pt', format: 'letter', orientation: 'portrait' },
			pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
		};

		html2pdf()
			.set(opt)
			.from(input)
			.toPdf()
			.get('pdf')
			.then(function (pdf) {
				window.open(pdf.output('bloburl'), '_blank');
			});
		this.stopLoader();
	};

	openLoanAgreement = () => {
		this.setState({
			_open: 'LOAN_AGREEMENT'
		});
	};

	openLoanAgreementLenderGuarantor = () => {
		this.setState({
			_open: 'LOAN_AGREEMENT_GUARANTOR_LENDER'
		});
	};

	openLoanAgreementBorrowerGuarantor = () => {
		this.setState({
			_open: 'LOAN_AGREEMENT_GUARANTOR_BORROWER'
		});
	};

	closeLoanAgreement = () => {
		this.setState({
			_open: 'DOWNLOAD_DOCUMENTS'
		});
	};

	openAmortizationTable = () => {
		this.setState({
			_open: 'AMORTIZATION'
		});
	};

	closeAmortizationTable = () => {
		if (this.props.props.match.path === '/amortization-table/:id') {
			this.props.props.history.push('/');
		}
		this.setState({
			_fromModifiedState: false,
			_open: 'DETAILS',
			_refreshWhenModifiedClose: false
		});
	};

	openDownloadDocuments = () => {
		this.setState({
			_open: 'DOWNLOAD_DOCUMENTS'
		});
	};

	closeDownloadDocuments = () => {
		this.setState({
			_fromModifiedState: false,
			_open: 'DETAILS',
			_refreshWhenModifiedClose: false
		});
	};

	openSeeModification = () => {
		this.setState({
			_fromModifiedState: true,
			_open: 'VIEW_MODIFICATION'
		});
	};

	openModifyFlow = () => {
		this.setState({
			_open: 'MODIFY_PAGE'
		});
	};

	closeModifyFlow = () => {
		if (this.props.props.match.path === '/modify-loan/:id') {
			this.props.props.history.push('/');
		}
		this.setState({
			_refreshWhenModifiedClose: true,
			_open: 'DETAILS'
		});
	};

	closeSeeModification = () => {
		if (this.props.props.match.path === '/modify-loan/:id') {
			this.props.props.history.push('/');
		}
		this.setState({
			_fromModifiedState: false,
			_refreshWhenModifiedClose: true,
			_open: 'DETAILS'
		});
	};

	openUpdateFlow = () => {
		this.setState({
			_open: 'UPDATE',
			_refreshWhenModifiedClose: true
		});
	};

	closeUpdateFlow = () => {
		// NOSONAR
		this.setState({
			_open: 'DETAILS'
		});
	};

	getLoanObjects = async () => {
		this.startLoader();
		try {
			const [loanObjects, loanObjectsGuarantor] = await Promise.allSettled([
				LoanService.get('loan/get-my-loans'),
				LoanService.get('loan/get-my-loans-guarantor')
			]);
			await this.processLoanObject(loanObjects.value);
			await this.processGuarantorLoanObject(loanObjectsGuarantor.value);
			if (!this.state._whenRefresh) {
				this.setScreenThroughRouters();
			}
			this.stopLoader();
		} catch (error) {
			console.log(error);
			this.stopLoader();
		}
	};

	openLoanDetails = id => {
		const hashedLoanObjects = {
			...this.state._hashedLoanObjects
		};
		this.setState({
			_loanObject: hashedLoanObjects[id],
			_open: 'DETAILS'
		});
	};

	refreshLoanObject = async () => {
		const loanObject = this.state._loanObject;
		this.setState({
			_whenRefresh: true
		});
		await this.getLoanObjects();
		if (loanObject && this.state._hashedLoanObjects[loanObject.id]) {
			this.setState({
				_loanObject: this.state._hashedLoanObjects[loanObject.id]
			});
		}
	};

	setCurrentUser = () => {
		const currentUser = Session.get(APP_STRING.CURRENT_USER_INFO);
		this.setState({
			_currentUserId: currentUser.username,
			userType: this.props.userType
		});
	};

	componentDidMount() {
		this.setCurrentUser();
		this.getLoanObjects();
	}

	setModifiedData = data => {
		this.setState({
			_modifiedAmortization: data
		});
	};

	render() {
		// NOSONAR
		console.log(this.state._loanObject);
		if (this.state._open === 'LIST') {
			return (
				<section>
					<List
						currentUserId={this.state._currentUserId}
						handleBackFromList={this.handleBackFromList}
						LoanObjects={LoanObjects}
						loanListObject={this.state._loanListObjects}
						openLoanDetail={this.openLoanDetails}
						props={this.props.props}
						refreshState={this.refreshLoanObject}
						tableType={this.state._tableType}
						parentState={this.state}
					/>
				</section>
			);
		} else if (this.state._open === 'DETAILS' && this.state.userType === 'USER') {
			return (
				<Details
					closeAmortizationTable={this.closeAmortizationTable}
					closeLoanDetail={this.closeLoanDetail}
					currentUser={this.props.currentUser}
					currentUserId={this.state._currentUserId}
					hashedSupportedStates={this.props.hashedSupportedStates}
					loanObject={this.state._loanObject}
					modifyFlow={this.openModifyFlow}
					openAmortizationTable={this.openAmortizationTable}
					openLoanAgreement={this.openLoanAgreement}
					openLoanAgreementLenderGuarantor={this.openLoanAgreementLenderGuarantor}
					openLoanAgreementBorrowerGuarantor={this.openLoanAgreementBorrowerGuarantor}
					openScreen={this.props.openScreen}
					openSeeModification={this.openSeeModification}
					openUpdateFlow={this.openUpdateFlow}
					props={this.props.props}
					refreshState={this.refreshLoanObject}
					refreshWhenModifiedClose={this.state._refreshWhenModifiedClose}
					setCurrentUser={this.props.setCurrentUser}
					supportedRelationships={this.props.supportedRelationships}
					supportedStates={this.props.supportedStates}
					openDownloadDocuments={this.openDownloadDocuments}
					closeDownloadDocuments={this.closeDownloadDocuments}
					loading={this.state._isObjectLoading}
				/>
			);
		} else if (this.state._open === 'DETAILS' && this.state.userType === 'GUARANTOR') {
			return (
				<DetailsGuarantor
					closeAmortizationTable={this.closeAmortizationTable}
					closeLoanDetail={this.closeLoanDetail}
					supportedStates={this.props.supportedStates}
					hashedSupportedStates={this.props.hashedSupportedStates}
					loanObject={this.state._loanObject}
					modifyFlow={this.openModifyFlow}
					openAmortizationTable={this.openAmortizationTable}
					currentUser={this.props.currentUser}
					currentUserId={this.state._currentUserId}
					openLoanAgreement={this.openLoanAgreement}
					openLoanAgreementLenderGuarantor={this.openLoanAgreementLenderGuarantor}
					openLoanAgreementBorrowerGuarantor={this.openLoanAgreementBorrowerGuarantor}
					openScreen={this.props.openScreen}
					openSeeModification={this.openSeeModification}
					openUpdateFlow={this.openUpdateFlow}
					refreshWhenModifiedClose={this.state._refreshWhenModifiedClose}
					setCurrentUser={this.props.setCurrentUser}
					props={this.props.props}
					refreshState={this.refreshLoanObject}
					supportedRelationships={this.props.supportedRelationships}
				/>
			);
		} else if (this.state._open === 'UPDATE') {
			return (
				<UpdateLoan
					closeUpdateFlow={this.closeUpdateFlow}
					loanObject={this.state._loanObject}
					refreshState={this.refreshLoanObject}
				/>
			);
		} else if (this.state._open === 'LOAN_AGREEMENT') {
			return (
				<LoanAgreement
					closeLoanAgreement={this.closeLoanAgreement}
					currentUserId={this.state._currentUserId}
					hashedSupportedStates={this.props.hashedSupportedStates}
					loanObject={this.state._loanObject}
					onGeneratePdf={this.generatePDF}
				/>
			);
		} else if (this.state._open === 'LOAN_AGREEMENT_GUARANTOR_LENDER') {
			return (
				<LoanAgreementGuarantorLender
					closeLoanAgreement={this.closeLoanAgreement}
					loanObject={this.state._loanObject}
					currentUserId={this.state._currentUserId}
					hashedSupportedStates={this.props.hashedSupportedStates}
					onGeneratePdf={this.generatePDF}
				/>
			);
		} else if (this.state._open === 'LOAN_AGREEMENT_GUARANTOR_BORROWER') {
			return (
				<LoanAgreementGuarantorBorrower
					closeLoanAgreement={this.closeLoanAgreement}
					hashedSupportedStates={this.props.hashedSupportedStates}
					loanObject={this.state._loanObject}
					currentUserId={this.state._currentUserId}
					onGeneratePdf={this.generatePDF}
				/>
			);
		} else if (this.state._open === 'AMORTIZATION') {
			return (
				<section>
					<AmortizationTableComponent
						tableColor={this.state._tableColor}
						closeAmortizationTable={this.closeAmortizationTable}
						currentUser={this.props.currentUser}
						currentUserId={this.state._currentUserId}
						fromModifiedScreen={this.state._fromModifiedState}
						loanData={this.state._loanObject}
						loanObject={this.state._fromModifiedState ? this.state._loanObject : ''}
						name={this.state._loanObject.name}
						refreshState={this.refreshLoanObject}
						table={
							this.state._fromModifiedState
								? this.state._modifiedAmortization.installments
								: this.state._loanObject.installments
						}
						typeOfUser={
							checkIfLender(this.state._currentUserId, this.state._loanObject) ? 'LEND' : 'BORROW'
						}
					/>
				</section>
			);
		} else if (this.state._open === 'DOWNLOAD_DOCUMENTS') {
			return (
				<DownloadDocuments
					closeDownloadDocuments={this.closeDownloadDocuments}
					closeLoanDetail={this.closeLoanDetail}
					currentUser={this.props.currentUser}
					currentUserId={this.state._currentUserId}
					hashedSupportedStates={this.props.hashedSupportedStates}
					loanObject={this.state._loanObject}
					modifyFlow={this.openModifyFlow}
					openLoanAgreement={this.openLoanAgreement}
					openLoanAgreementLenderGuarantor={this.openLoanAgreementLenderGuarantor}
					openLoanAgreementBorrowerGuarantor={this.openLoanAgreementBorrowerGuarantor}
					openScreen={this.props.openScreen}
					openSeeModification={this.openSeeModification}
					openUpdateFlow={this.openUpdateFlow}
					props={this.props.props}
					refreshState={this.refreshLoanObject}
					refreshWhenModifiedClose={this.state._refreshWhenModifiedClose}
					setCurrentUser={this.props.setCurrentUser}
					supportedRelationships={this.props.supportedRelationships}
					supportedStates={this.props.supportedStates}
				/>
			);
		} else if (this.state._open === 'VIEW_MODIFICATION') {
			return (
				<section>
					<ViewModification
						closeSeeModification={this.closeSeeModification}
						currentUser={this.props.currentUser}
						currentUserId={this.state._currentUserId}
						hashedSupportedStates={this.props.hashedSupportedStates}
						loan={this.state._loanObject}
						loanObject={this.state._loanObject.modified_loan}
						modifiedObject={this.state._loanObject}
						openAmortizationTable={this.openAmortizationTable}
						openScreen={this.props.openScreen}
						refreshState={this.refreshLoanObject}
						setCurrentUser={this.props.setCurrentUser}
						setModifiedData={this.setModifiedData}
						supportedStates={this.props.supportedStates}
					/>
				</section>
			);
		} else if (this.state._open === 'MODIFY_PAGE') {
			return (
				<ModifyDetails
					closeAmortizationTable={this.closeAmortizationTable}
					closeLoanDetail={this.closeLoanDetail}
					closeModifyFlow={this.closeModifyFlow}
					currentUser={this.props.currentUser}
					currentUserId={this.state._currentUserId}
					loanObject={this.state._loanObject}
					openAmortizationTable={this.openAmortizationTable}
					openScreen={this.props.openScreen}
					props={this.props.props}
					refreshState={this.refreshLoanObject}
					refreshWhenModifiedClose={this.state._refreshWhenModifiedClose}
					setCurrentUser={this.props.setCurrentUser}
					supportedFrequency={this.props.supportedFrequency}
					supportedStates={this.props.supportedStates}
					tableType={this.state._tableType}
				/>
			);
		} else {
			return (
				<section>
					<Main
						lendPendingOffers={this.state._lendPendingOffers}
						lendPendingRequests={this.state._lendPendingRequests}
						borrowPendingOffers={this.state._borrowPendingOffers}
						borrowPendingRequests={this.state._borrowPendingRequests}
						borrowAccept={this.state._borrowApprove.length}
						borrowComplete={this.state._borrowCompleted.length}
						borrowDecline={this.state._borrowDecline.length}
						borrowModify={this.state._borrowModified.length}
						borrowPaused={this.state._borrowPaused.length}
						borrowPending={this.state._borrowPending.length}
						detectLoanTypeBorrow={this.detectLoanTypeBorrow}
						detectLoanTypeGuarantor={this.detectLoanTypeGuarantor}
						detectLoanTypeLend={this.detectLoanTypeLend}
						lendAccept={this.state._lendApprove.length}
						lendComplete={this.state._lendCompleted.length}
						lendDecline={this.state._lendDecline.length}
						lendModify={this.state._lendModified.length}
						lendPaused={this.state._lendPaused.length}
						lendPending={this.state._lendPending.length}
						guarantorAccept={this.state._guarantorAccepted.length}
						guarantorDecline={this.state._guarantorDecline.length}
						guarantorPending={this.state._guarantorPending.length}
						guarantorComplete={this.state._guarantorCompleted.length}
						props={this.props.props}
						setScreen={this.getLoanObjects}
						totalBorrowRequest={this.state._borrowLoanObjects.length}
						totalLendRequest={this.state._lendLoanObjects.length}
						totalGuarantorRequest={this.state._guarantorLoanObjects.length}
						currentUser={this.props.currentUser}
						currentUserId={this.state._currentUserId}
						detectLoanType={this.detectLoanType}
					/>
					{this.state._isObjectLoading ? <Loader /> : ''}
				</section>
			);
		}
	}

	processGuarantorLoanObject = async guarantorloanObjects => {
		const guarantorObjects = [];
		const hashedLoanObjects = {};
		for (const loanObject of guarantorloanObjects) {
			if (loanObject.loan_type === LOAN_TYPES.LEND) {
				loanObject.lender = {
					name: loanObject.created_by_user.name,
					email: loanObject.created_by_user.email,
					phone: loanObject.created_by_user.phone
				};
				if (loanObject.accepted_by_user && loanObject.accepted_by_user.name) {
					loanObject.borrower = {
						name: loanObject.accepted_by_user.name,
						email: loanObject.accepted_by_user.email,
						phone: loanObject.accepted_by_user.phone
					};
				} else {
					loanObject.borrower = {
						name: loanObject.invitation[0].name,
						email: loanObject.invitation[0].email,
						phone: loanObject.invitation[0].phone
					};
				}
			} else {
				loanObject.borrower = {
					name: loanObject.created_by_user.name,
					email: loanObject.created_by_user.email,
					phone: loanObject.created_by_user.phone
				};
				if (loanObject.accepted_by_user && loanObject.accepted_by_user.name) {
					loanObject.lender = {
						name: loanObject.accepted_by_user.name,
						email: loanObject.accepted_by_user.email,
						phone: loanObject.accepted_by_user.phone
					};
				} else {
					loanObject.lender = {
						name: loanObject.invitation[0].name,
						email: loanObject.invitation[0].email,
						phone: loanObject.invitation[0].phone
					};
				}
			}
			loanObject.name = loanObject.created_by_user.name;
			hashedLoanObjects[loanObject.id] = loanObject;
			guarantorObjects.push(loanObject);
		}
		this.setState({
			_guarantorLoanObjects: guarantorObjects,
			_hashedLoanObjects: {
				...this.state._hashedLoanObjects,
				...hashedLoanObjects
			}
		});
		if (this.state._tableType === 'GUARANTOR') {
			LoanObjects = this.state._guarantorLoanObjects;
		}
		await this.filterGuarantorObjects();
	};
	processLoanObject = async loanObjects => {
		// NOSONAR
		const lendLoanObjects = [];
		const borrowLoanObjects = [];
		const hashedLoanObjects = {};

		for (const loanObject of loanObjects) {
			let guarantor_data = {};
			if (loanObject.guarantor_exist) {
				// NOSONAR

				if (loanObject.guarantor_details[0]) {
					const d = loanObject.guarantor_details[0];
					guarantor_data.name = d.name ? d.name : 'None';
					guarantor_data.email = d.email ? d.email : 'None';
					guarantor_data.phone = d.phone ? d.phone : 'None';
				} else if (loanObject.guarantor_inv_details[0]) {
					const d = loanObject.guarantor_inv_details[0];
					guarantor_data.name = d.guarantor_name ? d.guarantor_name : 'None';
					guarantor_data.email = d.guarantor_email ? d.guarantor_email : 'None';
					guarantor_data.phone = d.guarantor_phone ? d.guarantor_phone : 'None';
				} else {
					guarantor_data.name = 'None';
					guarantor_data.email = 'None';
					guarantor_data.phone = 'None';
				}

				loanObject.guarantor_data = guarantor_data;
			}
			if (loanObject.loan_type === LOAN_TYPES.LEND) {
				if (loanObject.accepted_by === this.state._currentUserId) {
					loanObject.name = loanObject.created_by_user.name;
					borrowLoanObjects.push(loanObject);
					hashedLoanObjects[loanObject.id] = loanObject;
					continue;
				}
				loanObject.name = loanObject.accepted_by_user.name;
				lendLoanObjects.push(loanObject);
				hashedLoanObjects[loanObject.id] = loanObject;
			} else {
				if (loanObject.accepted_by === this.state._currentUserId) {
					loanObject.name = loanObject.created_by_user.name;
					lendLoanObjects.push(loanObject);
					hashedLoanObjects[loanObject.id] = loanObject;
					continue;
				}
				loanObject.name = loanObject.accepted_by_user.name;
				borrowLoanObjects.push(loanObject);
				hashedLoanObjects[loanObject.id] = loanObject;
			}
		}
		this.setState({
			_loanListObjects: loanObjects,
			_lendLoanObjects: lendLoanObjects,
			_borrowLoanObjects: borrowLoanObjects,
			_hashedLoanObjects: {
				...this.state._hashedLoanObjects,
				...hashedLoanObjects
			}
		});
		if (this.state._tableType === 'LEND') {
			LoanObjects = this.state._lendLoanObjects;
		} else if (this.state._tableType === 'BORROW') {
			LoanObjects = this.state._borrowLoanObjects;
		}
		await this.filterLendLoanObject();
		await this.filterBorrowLoanObject();
	};

	filterLendLoanObject = async () => {
		const lendPendingObject = [];
		const lendAcceptObject = [];
		const lendDeclineObject = [];
		const lendModifyObject = [];
		const lendCompleteObject = [];
		const lendPausedObject = [];
		const lendPendingOffersObject = [];
		const borrowPendingRequestsObject = [];
		const lendLoanObjects = this.state._lendLoanObjects;

		for (const loanObj of lendLoanObjects) {
			//drafted to be removed since technically this is not part of loan pending
			// if (loanObj.state === LOAN_STATES.PENDING || loanObj.state === LOAN_STATES.DRAFTED) {
			if (loanObj.state === LOAN_STATES.PENDING) {
				// count lend
				// lendPendingObject.push(loanObj);
				if (loanObj.loan_type === LOAN_TYPES.LEND) {
					lendPendingOffersObject.push(loanObj);
					// this.setState({
					// 	_lendPendingOffers: [...this.state._lendPendingOffers, loanObj]
					// });
				} else if (loanObj.loan_type === LOAN_TYPES.BORROW) {
					if (
						loanObj.created_by !== this.state._currentUserId &&
						loanObj.accepted_by == this.state._currentUserId
					) {
						lendPendingObject.push(loanObj);
					} else {
						borrowPendingRequestsObject.push(loanObj);
					}
					// this.setState({
					// 	_borrowPendingRequests: [...this.state._borrowPendingRequests, loanObj]
					// });
				}
			} else if (loanObj.state === LOAN_STATES.APPROVE) {
				lendAcceptObject.push(loanObj);
			} else if (loanObj.state === LOAN_STATES.DECLINE) {
				lendDeclineObject.push(loanObj);
			} else if (loanObj.state === LOAN_STATES.POST_MODIFIED || loanObj.state === LOAN_STATES.PRE_MODIFIED) {
				lendModifyObject.push(loanObj);
			} else if (loanObj.state === LOAN_STATES.COMPLETED) {
				lendCompleteObject.push(loanObj);
			} else if (loanObj.state === LOAN_STATES.PAUSED || loanObj.state === LOAN_STATES.EMI_STOPED) {
				lendPausedObject.push(loanObj);
			}
		}
		this.setState({
			_lendPendingOffers: lendPendingOffersObject,
			_borrowPendingRequests: borrowPendingRequestsObject,
			_lendPending: lendPendingObject,
			_lendApprove: lendAcceptObject,
			_lendDecline: lendDeclineObject,
			_lendModified: lendModifyObject,
			_lendCompleted: lendCompleteObject,
			_lendPaused: lendPausedObject
		});
	};

	filterBorrowLoanObject = async () => {
		const borrowPendingObject = [];
		const borrowAcceptObject = [];
		const borrowDeclineObject = [];
		const borrowModifyObject = [];
		const borrowCompleteObject = [];
		const borrowPausedObject = [];
		const borrowPendingOffersObject = [];
		const borrowPendingRequestsObject = [];
		const borrowObjects = this.state._borrowLoanObjects;
		for (const loanObj of borrowObjects) {
			//drafted to be removed since technically this is not part of loan pending
			if (loanObj.state === LOAN_STATES.PENDING || loanObj.state === LOAN_STATES.DRAFTED) {
				borrowPendingObject.push(loanObj);

				if (loanObj.created_by !== this.state._currentUserId) {
					borrowPendingOffersObject.push(loanObj);
					// this.setState({
					// 	_borrowPendingOffers: [...this.state._borrowPendingOffers, loanObj]
					// });
				} else if (loanObj.created_by === this.state._currentUserId) {
					borrowPendingRequestsObject.push(loanObj);
					// this.setState({
					// 	_borrowPendingRequests: [...this.state._borrowPendingRequests, loanObj]
					// });
				}
			} else if (loanObj.state === LOAN_STATES.APPROVE) {
				borrowAcceptObject.push(loanObj);
			} else if (loanObj.state === LOAN_STATES.DECLINE) {
				borrowDeclineObject.push(loanObj);
			} else if (loanObj.state === LOAN_STATES.POST_MODIFIED || loanObj.state === LOAN_STATES.PRE_MODIFIED) {
				borrowModifyObject.push(loanObj);
			} else if (loanObj.state === LOAN_STATES.COMPLETED) {
				borrowCompleteObject.push(loanObj);
			} else if (loanObj.state === LOAN_STATES.PAUSED || loanObj.state === LOAN_STATES.EMI_STOPED) {
				borrowPausedObject.push(loanObj);
			}
		}
		this.setState({
			_borrowPendingOffers: borrowPendingOffersObject,
			_borrowPendingRequests: borrowPendingRequestsObject,
			_borrowPending: borrowPendingObject,
			_borrowApprove: borrowAcceptObject,
			_borrowDecline: borrowDeclineObject,
			_borrowModified: borrowModifyObject,
			_borrowCompleted: borrowCompleteObject,
			_borrowPaused: borrowPausedObject
		});
	};
	filterGuarantorObjects = async () => {
		const guarantorPendingObject = [];
		const guarantorAcceptObject = [];
		const guarantorDeclineObject = [];
		const guarantorCompleteObject = [];
		const guarantorObjects = this.state._guarantorLoanObjects;
		for (const loanObj of guarantorObjects) {
			if (!loanObj.guarantor_action) {
				guarantorPendingObject.push(loanObj);
			} else if (loanObj.guarantor_action && loanObj.guarantor_action === GUARANTOR_STATE.REJECT) {
				guarantorDeclineObject.push(loanObj);
			} else if (
				loanObj.guarantor_action &&
				loanObj.guarantor_action === GUARANTOR_STATE.ACCEPT &&
				loanObj.state !== LOAN_STATES.COMPLETED
			) {
				guarantorAcceptObject.push(loanObj);
			} else if (
				loanObj.guarantor_action &&
				loanObj.guarantor_action === GUARANTOR_STATE.ACCEPT &&
				loanObj.state === LOAN_STATES.COMPLETED
			) {
				guarantorCompleteObject.push(loanObj);
			}
		}
		this.setState({
			_guarantorPending: guarantorPendingObject,
			_guarantorDecline: guarantorDeclineObject,
			_guarantorAccepted: guarantorAcceptObject,
			_guarantorCompleted: guarantorCompleteObject
		});
	};

	detectLoanType = type => {
		this.setState({
			_open: type.openType,
			_tableType: type.tableType,
			userType: type.userType,
			_pageHeaderTitle: type.label,
			_pageHeaderDescription: type.description,
			_tableColor: type.tableColor
		});

		if (type.tableType === 'LEND') {
			LoanObjects = this.state._lendLoanObjects;
		}
		// else if (type === 'LEND_PENDING') {
		// 	LoanObjects = this.state._lendPending;
		// } else if (type === 'LEND_DECLINE') {
		// 	LoanObjects = this.state._lendDecline;
		// } else if (type === 'LEND_ACCEPT') {
		// 	LoanObjects = this.state._lendApprove;
		// } else if (type === 'LEND_MODIFY') {
		// 	LoanObjects = this.state._lendModified;
		// } else if (type === 'LEND_COMPLETED') {
		// 	LoanObjects = this.state._lendCompleted;
		// } else if (type === 'LEND_PAUSED') {
		// 	LoanObjects = this.state._lendPaused;
		// }

		if (type.tableType === 'BORROW') {
			LoanObjects = this.state._borrowLoanObjects;
		}
		// else if (type === 'BORROW_PENDING') {
		// 	LoanObjects = this.state._borrowPending;
		// } else if (type === 'BORROW_DECLINE') {
		// 	LoanObjects = this.state._borrowDecline;
		// } else if (type === 'BORROW_ACCEPT') {
		// 	LoanObjects = this.state._borrowApprove;
		// } else if (type === 'BORROW_MODIFY') {
		// 	LoanObjects = this.state._borrowModified;
		// } else if (type === 'BORROW_COMPLETED') {
		// 	LoanObjects = this.state._borrowCompleted;
		// } else if (type === 'BORROW_PAUSED') {
		// 	LoanObjects = this.state._borrowPaused;
		// }

		if (type.tableType === 'GUARANTOR') {
			LoanObjects = this.state._guarantorLoanObjects;
		}
		// else if (type === 'GUARANTOR_PENDING') {
		// 	LoanObjects = this.state._guarantorPending;
		// } else if (type === 'GUARANTOR_DECLINE') {
		// 	LoanObjects = this.state._guarantorDecline;
		// } else if (type === 'GUARANTOR_ACCEPT') {
		// 	LoanObjects = this.state._guarantorAccepted;
		// } else if (type === 'GUARANTOR_COMPLETED') {
		// 	LoanObjects = this.state._guarantorCompleted;
		// }
	};

	detectLoanTypeLend = type => {
		this.setState({
			_open: 'LIST',
			_tableType: 'LEND',
			userType: 'USER'
		});
		if (type === 'LEND') {
			LoanObjects = this.state._lendLoanObjects;
		} else if (type === 'LEND_PENDING') {
			LoanObjects = this.state._lendPending;
		} else if (type === 'LEND_DECLINE') {
			LoanObjects = this.state._lendDecline;
		} else if (type === 'LEND_ACCEPT') {
			LoanObjects = this.state._lendApprove;
		} else if (type === 'LEND_MODIFY') {
			LoanObjects = this.state._lendModified;
		} else if (type === 'LEND_COMPLETED') {
			LoanObjects = this.state._lendCompleted;
		} else if (type === 'LEND_PAUSED') {
			LoanObjects = this.state._lendPaused;
		}
	};

	detectLoanTypeBorrow = type => {
		this.setState({
			_open: 'LIST',
			_tableType: 'BORROW',
			userType: 'USER'
		});
		if (type === 'BORROW') {
			LoanObjects = this.state._borrowLoanObjects;
		} else if (type === 'BORROW_PENDING') {
			LoanObjects = this.state._borrowPending;
		} else if (type === 'BORROW_DECLINE') {
			LoanObjects = this.state._borrowDecline;
		} else if (type === 'BORROW_ACCEPT') {
			LoanObjects = this.state._borrowApprove;
		} else if (type === 'BORROW_MODIFY') {
			LoanObjects = this.state._borrowModified;
		} else if (type === 'BORROW_COMPLETED') {
			LoanObjects = this.state._borrowCompleted;
		} else if (type === 'BORROW_PAUSED') {
			LoanObjects = this.state._borrowPaused;
		}
	};
	detectLoanTypeGuarantor = type => {
		this.setState({
			_open: 'LIST',
			_tableType: 'GUARANTOR',
			userType: 'GUARANTOR'
		});
		if (type === 'GUARANTOR') {
			LoanObjects = this.state._guarantorLoanObjects;
		} else if (type === 'GUARANTOR_PENDING') {
			LoanObjects = this.state._guarantorPending;
		} else if (type === 'GUARANTOR_DECLINE') {
			LoanObjects = this.state._guarantorDecline;
		} else if (type === 'GUARANTOR_ACCEPT') {
			LoanObjects = this.state._guarantorAccepted;
		} else if (type === 'GUARANTOR_COMPLETED') {
			LoanObjects = this.state._guarantorCompleted;
		}
	};
}

export default Index;
